import type { ReactNode } from 'react';

interface LegalComplianceSectionBaseProps {
  legalUrlFields: ReactNode;
}

export function LegalComplianceSectionBase({
  legalUrlFields,
}: LegalComplianceSectionBaseProps) {
  return <section className="flex flex-col gap-6">{legalUrlFields}</section>;
}
